const ADD_SCROLL_CLASS_AFTER = 100;
const REMOVE_SCROLL_CLASS_AFTER = 20;

/**
 * Updates custom CSS properties for the header height and combined header and navigation heights
 * based on the provided site header and section navigation elements.
 *
 * @param {HTMLElement} siteHeader - The site header element used to calculate its height.
 *
 * @return {void}
 */
function updateHeightCustomProperty(siteHeader) {
	const siteHeaderHeight = siteHeader.offsetHeight;
	document.body.style.setProperty(
		'--site-header-height',
		siteHeaderHeight + 'px'
	);
}

/**
 * Applies sticky header behavior to the site header and section navigation elements.
 * Saves the height of the site header and section navigation elements in custom properties to be used in CSS.
 *
 * @return {void}
 */
function stickyHeaders() {
	const siteHeader = document.querySelector('#masthead');

	// Check if the site header exists.
	if (!siteHeader) {
		return;
	}

	// Observe siteHeader and section navs for resizing.
	const observer = new ResizeObserver(() => {
		updateHeightCustomProperty(siteHeader);
	});

	// TODO: Only needed when other elements care about the height of the header.
	observer.observe(siteHeader);

	let ticking = false;

	// Listen for the page to scroll and add a class to the body once it's past a certain point.
	window.addEventListener('scroll', () => {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				if (window.scrollY > ADD_SCROLL_CLASS_AFTER) {
					document.body.classList.add('has-scrolled');
				} else if (window.scrollY < REMOVE_SCROLL_CLASS_AFTER) {
					document.body.classList.remove('has-scrolled');
				}
				ticking = false;
			});
			ticking = true;
		}
	});
}

export { stickyHeaders };
